import React, { useEffect, useState } from 'react';
import DynamicColorSidebar from './DynamicColorSidebar';
import styles from './LeftSidebar.module.css';

type Props = {
  onTitleClick?: () => void;
  forceFixedTop?: boolean; // quando true (vista grid) resta in alto fisso
  isProjectMode?: boolean;
  /** Riga sotto il nome. Usata dalle pagine dei link privati per il nome del link. */
  sottotitolo?: string;
};

const LeftSidebar: React.FC<Props> = ({ onTitleClick, forceFixedTop = false, isProjectMode = false, sottotitolo }) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollTop: number = window.pageYOffset;
      // Su mobile, sempre sticky. Su desktop, sticky solo quando scrollato
      const isMobile = window.innerWidth <= 768;
      setIsScrolled(isMobile || scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    // Controlla anche al resize per gestire il cambio da desktop a mobile
    window.addEventListener('resize', handleScroll);
    
    // Controlla inizialmente
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const stickyClass = forceFixedTop ? styles.sticky : isScrolled ? styles.sticky : '';
  const projectModeClass = isProjectMode ? styles.projectMode : '';

  return (
    <DynamicColorSidebar className={`${styles.leftSidebar} ${stickyClass} ${projectModeClass}`} disableColorChange={isProjectMode}>
      <div className={styles.blocco}>
        <h1 className={styles.heroName} onClick={onTitleClick} style={{ cursor: onTitleClick ? 'pointer' : 'default' }}>
          ĀLESSIĀ MĀSTRORILLI
        </h1>
        {sottotitolo && <span className={styles.sottotitolo}>{sottotitolo}</span>}
      </div>
    </DynamicColorSidebar>
  );
};

export default LeftSidebar;
